import script from "./Stepper.vue?vue&type=script&setup=true&lang=ts&generic=U%20extends%20string%7Cnumber"
export * from "./Stepper.vue?vue&type=script&setup=true&lang=ts&generic=U%20extends%20string%7Cnumber"

const __exports__ = script;

export default __exports__